import { ISiteColors } from "./company-atts";

export const AllKrkColors:ISiteColors = {
    headerColor: "rgb(143, 186, 0)",//Цвет хедера
    headerShadow:   "0px 1px 4px #8fba00", //Тень от хедера
    headerTextColor:   "#fff", // Текст в поиске, колокольчик и иконка юзера
    headerDarkMenu:   "#3d4652",// Текст и иконка юзера, когда открыт текст
    footerColor:   "#3d4652",//Цвет футера
    footerLinkColor:  "#ffffff",//Цвет ссылок в футере
    footerCopyrightColor:   "#949495",//Цвет текста копирайта в футере
    ComId:   34,
    backTotal:   "#3D4652",// - не используется
    backBtnSubmit:   "#8FBA00",// Цвет основных кнопок, кнопок корзины, сабмитов, сохранения
    backBtnTotalByMonth:   "#8FBA00",// Цвет кнопки "Начислено за месяц"
    backBtnTotalByMonthText:"#fff", // Цвет текста кнопки "Начислено за месяц"
    backBtnPayDebt:   "#F7CB45",//Цвет кнопки "Оплатить"
    backRoutePanel:   "#8FBA00",
    backgroundColor: "#3d4652",// - цвет заднего фона
    sideBarText:"#fff", // - цвет текста в сайдбаре
    searchField:"#ffffff80",// - цвет поля для поиска в хедере
    searchFieldStyle:"header__input", //-определяет цвет плейсхолдера (header__input\header__input_dark)
    cardBackgroundColor:"#4F5968",//-цвет заднего фона карточки контента
    cardColor:"#fff", // - цвет карточки контента
    titleColor:"#fff", //цвет заголовков
    chargeTextColor:"#8FBA00", //цвет начислений
}

export const appKRKIOSLink = "https://apps.apple.com/us/app/%D0%BA%D1%80%D0%BA/id1527236431"
export const appKRKAndroidLink = "https://play.google.com/store/apps/details?id=ru.krasabs.krk"
export const userAgreementKRKLink = "https://izba.kras-abs.ru/agrees/krk.html"
